import {makeAutoObservable} from "mobx";

export default class SettingStore {
    setting = []
    constructor() {
        makeAutoObservable(this)
    }

    setSetting(setting) {
        this.setting = setting
    }

}